import * as React from 'react';
import { translate, InjectedTranslateProps } from 'react-i18next';
import ChevronLeft from 'wix-ui-icons-common/ChevronLeft';
import * as css from './InitialEditTeamDetails.scss';
import EditTeamDetails from '../EditTeamDetails/EditTeamDetails';
import { CurrentUserState } from '../../redux/configure-store';
import { validateTeamName } from '../../services/validators';

import { Heading, Button, TextButton } from 'wix-style-react';

interface IInitialEditTeamDetailsProps extends InjectedTranslateProps {
  onSave(details: any): void;

  onBack(): void;

  currentUser: CurrentUserState;
  learnMoreLink: string;
}

class InitialEditTeamDetails extends React.PureComponent<
  IInitialEditTeamDetailsProps
> {
  state: any = { isValid: true, isUploading: false };
  private nameInput;

  validate(name: string) {
    const validationResult = validateTeamName(name);
    this.setState(validationResult);
  }

  onSubmit() {
    this.validate(this.state.details && this.state.details.name);
    if (this.state.isValid) {
      this.props.onSave(this.state.details);
    } else {
      this.nameInput && this.nameInput.focus();
    }
  }

  getCurrentUserName() {
    const { currentUser } = this.props;
    return (
      currentUser &&
      [currentUser.first, currentUser.last].filter(x => x).join(' ')
    );
  }

  render() {
    const { t, currentUser, learnMoreLink } = this.props;
    const { isUploading } = this.state;
    return (
      <div>
        <Heading
          appearance={'H1'}
          dataHook={'initialEditTeamDetails-header'}
          className={css.titleAnimation}
        >
          {t('initialEditTeamDetails.title')}
        </Heading>
        {JSON.stringify(this.state.userName)}
        <EditTeamDetails
          name={this.getCurrentUserName()}
          imageUrl={currentUser && currentUser.profileImage}
          onUpdateDetails={details => this.setState(() => ({ details }))}
          onUpdateUploadStatus={(_isUploading: boolean) =>
            this.setState({ isUploading: _isUploading })
          }
          validate={name => this.validate(name)}
          isValid={this.state.isValid}
          errorMessage={this.state.errorMessage}
          introClass={css.titleAnimation}
          teamNameClass={css.teamNameAnimation}
          teamLogoClass={css.teamLogoAnimation}
          delayNameInputFocus={true}
          extractRef={ref => (this.nameInput = ref)}
          learnMoreLink={learnMoreLink}
        />
        <div className={css.ctaButtons}>
          <TextButton
            dataHook={'initialEditTeamDetails-back-button'}
            onClick={this.props.onBack}
            size={'medium'}
            className={css.backButton}
            prefixIcon={<ChevronLeft />}
          >
            {t('initialEditTeamDetails.back')}
          </TextButton>
          <Button
            dataHook={'initialEditTeamDetails-save-button'}
            onClick={() => this.onSubmit()}
            disabled={isUploading}
            size={'large'}
            className={css.saveButton}
          >
            {t('initialEditTeamDetails.save')}
          </Button>
        </div>
      </div>
    );
  }
}

export default translate(null)(InitialEditTeamDetails);
